import React, { useEffect } from 'react';
import { useDashboardStore } from './Store_Home';
import {
  getMixedChartData,
  getItemGroupChartData,
  getKpiSendStatusData,
  getBatchDefectDoughnutData,
  getSummaryData
} from './Utils_Home';
import { useDateSelection } from './hooks/useDateSelection';
import { DashboardHeader } from './components/DashboardHeader';
import { SummaryCards } from './components/SummaryCards';
import { ChartsSection } from './components/default/ChartsSection';
import { TablesSection } from './components/default/TablesSection';
import DateRangePickerModal from './components/DateRangePickerModal';
import { DashboardLoading } from './components/DashboardLoading';

const DefaultPage: React.FC = () => {
  const {
    isLoading,
    hasLoadedOnce,
    dataSource,
    error,
    startDate,
    endDate,
    monthlyProductionData,
    itemGroupData,
    batchDefectData,
    kpiHistoryData,
    productionDetailData,
    kpiSendDetailData,
    mainTopData,
    fetchDashboardData,
    refreshData,
    updateDateRangeAndFetch
  } = useDashboardStore();

  const {
    showDatePicker,
    handleDateRangeChange,
    handleDateConfirm,
    handleDateCancel,
    handleQuickDateSelect,
    openDatePicker
  } = useDateSelection({
    onDateRangeUpdate: (from, to) => updateDateRangeAndFetch(from, to, undefined, { includeATypeData: true })
  });

  useEffect(() => {
    fetchDashboardData(undefined, { includeATypeData: true });
  }, [fetchDashboardData]);

  const mixedChartData = getMixedChartData(monthlyProductionData);
  const itemGroupChartData = getItemGroupChartData(itemGroupData);
  const kpiSendStatusData = getKpiSendStatusData(kpiHistoryData);
  const batchDefectDoughnutData = getBatchDefectDoughnutData(batchDefectData);

  const summaryData = getSummaryData(
    mainTopData,
    monthlyProductionData,
    itemGroupData,
    batchDefectData,
    kpiHistoryData
  );

  return (
    <div className="relative w-full h-full flex flex-col p-4 gap-4">
      <DashboardLoading isLoading={isLoading} hasLoadedOnce={hasLoadedOnce} />

      <DashboardHeader
        isLoading={isLoading}
        dataSource={dataSource}
        error={error}
        startDate={startDate}
        endDate={endDate}
        onQuickDateSelect={handleQuickDateSelect}
        onOpenDatePicker={openDatePicker}
        onRefresh={() => refreshData(undefined, { includeATypeData: true })}
      />

      <SummaryCards summaryData={summaryData} />

      <ChartsSection
        mixedChartData={mixedChartData}
        itemGroupChartData={itemGroupChartData}
        batchDefectDoughnutData={batchDefectDoughnutData}
        kpiSendStatusData={kpiSendStatusData}
      />

      <TablesSection
        productionDetailData={productionDetailData}
        kpiSendDetailData={kpiSendDetailData}
      />

      <div className="text-sm text-gray-500 text-center">
      마지막 업데이트: {summaryData.lastUpdateTime || new Date().toLocaleString('ko-KR')}
      </div>

      <DateRangePickerModal
        visible={showDatePicker}
        title="📅 조회기간 선택"
        from={startDate}
        to={endDate}
        onChange={handleDateRangeChange}
        onCancel={handleDateCancel}
        onConfirm={handleDateConfirm}
      />
    </div>
  );
};

export default DefaultPage;
